import Axios from 'axios';
import { OrderCircle_CONFIG } from '@/js/config.js';
const RESOURCE_NAME = OrderCircle_CONFIG.API_URL+'chat';

export default {
    getUsers() {
        return Axios.get(RESOURCE_NAME + '/users');
    }
};